import React from 'react';

const PageContact: React.FC = () => (
  <>
    <header className="page-header container">
      <h1>Contactgegevens</h1>
      <p className="header-sub-title">Heeft u een vraag over infraplannen.nl? Zie de <a href="/veelgestelde-vragen">veelgestelde vragen</a>.</p>
    </header>

    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ul>
              <li>
                Heeft u een vraag over infraplannen.nl, toegang of het delen van plannen: zie de veelgestelde vragen. Is uw vraag daarmee niet beantwoord? Neem gerust contact op met <a href="mailto:contact@infraplannen.nl">contact@infraplannen.nl</a>. We helpen u graag!
              </li>
              <li>
                Heeft u een vraag over technische specificaties of richtlijnen: zie de <a href="https://mijnaansluiting.atlassian.net/wiki/spaces/Wiki/pages/159744004/infraplannen.nl" target="_blank" rel="noreferrer">informatiepagina</a>.
              </li>
              <li>
                Bent u gebruiker van infraplannen.nl en heeft u ondersteuning nodig? Meld dit via de <a href="https://mijnaansluiting.atlassian.net/servicedesk/customer/portals" target="_blank" rel="noreferrer">servicedesk</a>. We helpen u graag!
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default PageContact;